import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";

import {Observable} from "rxjs";

import {Driver} from "@commons/models/domain/Driver";
import {Vehicle} from '@commons/models/domain/Vehicle';

import {DialogService} from "@shared/services/dialog.service";
import {BaseComponent} from "@shared/components/base-component";
import {WorkerModel} from "@shared/models/worker.model";
import {NewNavigationService} from "@shared/services/new-navigation.service";

import {
  DriverDeactivationModalComponent
} from "@layout/driver/details/tabs/driver-details-data-tab/driver-deactivation-modal/driver-deactivation-modal.component";
import {WorkerHttpService} from "@layout/driver/http-services/worker-http.service";
import {
  DriverUnarchiveModalComponent
} from "@layout/driver/details/tabs/driver-details-data-tab/driver-unarchive-modal/driver-unarchive-modal.component";
import {WorkerService} from "@layout/driver/services/worker.service";

@Component({
  selector: 'wm-driver-details-data-tab',
  templateUrl: './driver-details-data-tab.component.html',
  styleUrls: ['./driver-details-data-tab.component.less']
})
export class DriverDetailsDataTabComponent extends BaseComponent implements OnChanges, OnDestroy {

  @Input() driver?: Driver;

  filtered!: Observable<Vehicle[]>;
  vehicles?: Vehicle[];
  height = '';
  is4DriveAuthorized = false;
  isLoadingOrSaving = false;
  isChangingArchiveStatus = false;
  firstNameCtrl = new FormControl('', [Validators.required]);
  lastNameCtrl = new FormControl('', [Validators.required]);
  mobilePhoneCtrl = new FormControl('');
  phoneCtrl = new FormControl('');
  emailCtrl = new FormControl('', [Validators.email]);
  // vehicleCtrl = new FormControl(undefined, [Validators.required]);
  // is4driverEnabledCtrl = new FormControl(false);

  form = this.formBuilder.group({
    firstName: this.firstNameCtrl,
    lastName: this.lastNameCtrl,
    mobilePhone: this.mobilePhoneCtrl,
    phone: this.phoneCtrl,
    email: this.emailCtrl
    // vehicle: this.vehicleCtrl,
    // is4driverEnabled: this.is4driverEnabledCtrl,
  });

  get isArchiveDriverVisible(): boolean {
    return this.driver != null && this.driver?.Id > 0 && !this.driver.U && !this.isLoadingOrSaving;
  }

  constructor(
    private formBuilder: FormBuilder,
    private dialogService: DialogService,
    private workerHttpService: WorkerHttpService,
    private workerService: WorkerService,
    private newNavigationService: NewNavigationService,
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.driver != null) {
      // const driverVehicle = this.driver?.Id > 0 ? this.vehicles?.find(x => x.DR === this.driver?.Id) : undefined;
      this.form.patchValue({
        firstName: this.driver?.FN.trim() ?? '',
        lastName: this.driver?.LN.trim() ?? '',
        phone: this.driver?.Pn ?? '',
        mobilePhone: this.driver?.CN ?? '',
        email: this.driver?.Em ?? '',
        // vehicle: driverVehicle?.Nm,
      });
      if (this.driver.Id === 0) {
        this.form.markAllAsTouched();
      }
    }
  }

  // TODO nie da się tego użyć w web wymaga zmian w api
  private load4DriverStatus() {
    // const request = {
    //   Client: this.securityService.token.Clients![0],
    //   Server: "alfa01.tekom.pl",
    //   WorkerId: this.driver!.Id
    // } as getWorkerStateRequest;

    // this.driverHttpService.getWorkerState(request).subscribe(result => {
    // });
  }

  private subToDatabaseValueChanges() {
    // this.filtered = this.vehicleCtrl.valueChanges.pipe(
    //   map(filter => {
    //     const result = filter ? this.filterItems(filter) : this.vehicles!.slice();
    //     this.height = result.length < 4 ? (result.length * 50 + 'px') : '200px';
    //     return result;
    //   }));
  }

  // private filterItems(filter: string): Vehicle[] {
  //   const filterValue = filter.toLowerCase();
  //   return this.vehicles!.filter(option => option.RN.toLowerCase().includes(filterValue));
  // }

  onSave() {
    this.form.markAllAsTouched();

    if (this.form.invalid)
      return;

    this.isLoadingOrSaving = true;

    const isAdd = !this.driver?.Id;
    const worker = this.getWorker(isAdd);
    const driver = this.workerToDriver(worker);

    if (isAdd) {
      this.workerHttpService.add(worker).subscribe(result => {
        this.workerService.newUnsavedDriver = undefined;
        driver!.Id = worker!.Id = +result!;
        this.workerService.workerAddedSubject.next(driver);
        this.isLoadingOrSaving = false;
      });
    } else {
      this.workerHttpService.update(worker).subscribe(() => {
        this.workerService.workerUpdatedSubject.next(driver);
        this.isLoadingOrSaving = false;
      });
    }
  }

  private workerToDriver(worker: WorkerModel): Driver {
    const driver = {} as Driver;
    driver.Id = worker.Id;
    driver.FN = worker.FirstName;
    driver.LN = worker.LastName;
    driver.Pn = worker.PhoneNumber;
    driver.CN = worker.CellphoneNumber;
    driver.Em = worker.Email ?? '';
    return driver;
  }

  private getWorker(isForAdd = true): WorkerModel {
    const worker = {} as WorkerModel;
    worker.Id = this.driver!.Id;
    worker.FirstName = this.firstNameCtrl.value!;
    worker.LastName = this.lastNameCtrl.value!;
    worker.PhoneNumber = this.phoneCtrl.value!;
    worker.CellphoneNumber = this.mobilePhoneCtrl.value!;
    worker.Email = this.emailCtrl.value!;
    worker.FourDriverAccess = false;
    worker.AssignedVehicle = undefined;

    if (isForAdd) { //nie ma możliwości aktualizacji tych 2 pól
      worker.OrganizationalUnitId = 1;
      worker.JobPositionId = 1;
    }

    return worker;
  }

  onChangeIsArchive() {
    if (this.isLoadingOrSaving)
      return;

    if (this.driver?.IsArchive) {
      this.unArchive();
    } else {
      this.archive();
    }
  }

  private archive() {
    this.dialogService.open(DriverDeactivationModalComponent, this.getWorker())
      .beforeClosed().subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.isChangingArchiveStatus = true;
        this.workerHttpService.archive(this.driver!.Id).subscribe(() => {
          this.newNavigationService.toWorkersList();
          this.driver!.IsArchive = true;
          this.workerService.archivedWorkerSubject.next(this.driver!);
          this.isChangingArchiveStatus = false;
        });
      }
    });
  }

  private unArchive() {
    this.dialogService.open(DriverUnarchiveModalComponent, this.getWorker())
      .beforeClosed().subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.isChangingArchiveStatus = true;
        this.workerHttpService.unarchive(this.driver!.Id).subscribe(() => {
          this.newNavigationService.toWorkersList();
          this.driver!.IsArchive = false;
          this.workerService.unArchivedWorkerSubject.next(this.driver!);
          this.isChangingArchiveStatus = false;
        });
      }
    });
  }

}
